/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"


export type Vendor = {
    vendor_id: number
    vendor_name: string
}
  

export type Response = {
  payload: Vendor[]
}

export function useVendorList() {
  const api = useApi()
  const [data, setData] = useState<Response["payload"]>([])
  const [isLoading, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)

    api
      .get("/vendor/")
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload

        setData(data)
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false))
  }

  const refetch = () => fetchData()

  useEffect(() => {
    fetchData()

    return () => {
      setData([])
      setLoading(false)
    }
  }, [])

  return {
    data,
    isLoading,
    dropdown: data?.map((item) => ({
      ...item,
      label: item.vendor_name,
      value: item.vendor_id.toString()
    })),
    refetch
  }
}
